export default "__VITE_ASSET__BAQBBQSW__"